import React, { useState, useEffect } from 'react';

import analyticService from '../../../services/analytics';
import { dateService } from '../../../services/date';
import { session } from '../../../services/session';
import { ratesService } from './rates-service';

import PaymentModelsDropdown from './payment-models-dropdown';
import RetailersDropdown from './retailers-dropdown';
import StrategiesDropdown from './strategies-dropdown';
import ConfirmDropdown from './confirm-dropdown';
import OverviewTable from './overview-table';
import SearchBar from './search-bar';
import DatePicker from '../../base/date/date-picker';

import './styles/retailer-overview.scss';

const merchants = [
  { slug: 'modaoperandi', merchant_name: 'Moda Operandi' },
  { slug: 'LordTaylor', merchant_name: 'Lord & Taylor' },
  { slug: 'violetgrey', merchant_name: 'Violet Grey' },
  { slug: 'dermstore', merchant_name: 'Dermstore' },
  { slug: 'bergdorf', merchant_name: 'Bergdorf Goodman' },
  { slug: 'yoox', merchant_name: 'Yoox' },
  { slug: 'Shoescribe', merchant_name: 'Shoescribe' },
  { slug: 'TheCorner', merchant_name: 'The Corner' },
  { slug: 'MyTheresa', merchant_name: 'MyTheresa' },
  { slug: 'Caudalie', merchant_name: 'Caudalie' },
  { slug: 'Kerastase', merchant_name: 'Kerastase' },
  { slug: 'ShuUemura', merchant_name: 'Shu Uemura' },
  { slug: 'Avenue32', merchant_name: 'Avenue 32' },
  { slug: 'Editorialist', merchant_name: 'Editorialist' },
  { slug: 'Ssense', merchant_name: 'Ssense' },
  { slug: 'Target', merchant_name: 'Target' },
  { slug: 'matchesfashion', merchant_name: 'MatchesFashion' },
  { slug: 'Farfetch', merchant_name: 'Farfetch' },
  { slug: 'luckyshops_logo', merchant_name: 'The Glamour Shop' },
  { slug: 'macys', merchant_name: "Macy's" },
  { slug: 'Clinique', merchant_name: 'Walmart' },
  { slug: 'EsteeLauder', merchant_name: 'Estee Lauder' },
  { slug: 'Barneys', merchant_name: 'Barneys New York' },
  { slug: 'Luisaviaroma', merchant_name: 'Luisaviaroma' },
  { slug: 'ShopBazaar', merchant_name: 'ShopBazaar' },
  { slug: 'Intermix', merchant_name: 'Drugstore.com' },
  { slug: 'CVS', merchant_name: 'CVS' },
  { slug: 'forward', merchant_name: 'Forward by Elyse Walker' },
  { slug: 'OkiNi', merchant_name: 'Oki-ni' },
  { slug: 'Totokaelo', merchant_name: 'Totokaelo' },
  { slug: 'KBeauty', merchant_name: 'KBeauty' },
  { slug: 'DiptyqueParis', merchant_name: 'diptyque Paris' },
];

const feeTypes = ['marketplace', 'direct_deal'];
const strategyStatuses = ['upcoming', 'expired', 'running_and_active', 'running_and_paused'];

const mockResponse = merchants.map((merch, idx) => {
  const merchId = 1000 + idx;
  const logoUrl = `https://static.bam-x.com/assets/logos/merchants/${merch.slug}.png`;
  const pricingModel = Math.floor(Math.random() * 4) + 1;
  const marketplaceEPC = parseFloat(Math.random()).toFixed(2);
  const commissionRate =
    pricingModel !== 2 && pricingModel !== 4
      ? String(Math.floor(Math.random() * 100))
      : parseFloat(Math.random()).toFixed(2);
  const evergreenRate =
    pricingModel !== 2 && pricingModel !== 4
      ? String(Math.floor(Math.random() * 100))
      : parseFloat(Math.random()).toFixed(2);
  const publisherEPC = parseFloat(Math.random()).toFixed(2);
  const clicks = Math.floor(Math.random() * 10000);
  const publisherTotalEarnings = (parseFloat(publisherEPC) * clicks).toFixed(2);

  const strategies = [];
  for (let i = 0; i < Math.floor(Math.random() * 10); i++) {
    const epc = parseFloat(Math.random()).toFixed(2);
    const clicks = Math.floor(Math.random() * 10000);

    const startOffset = Math.floor(Math.random() * 90) * [1, -1][Math.round(Math.random())];
    const endOffset = startOffset + Math.random() * 90;
    const now = dateService.getDateTime();
    const start = dateService.offsetFromDate(now, startOffset);
    const end = dateService.offsetFromDate(now, endOffset);
    const currentStrategyStatus =
      startOffset > 0
        ? strategyStatuses[0]
        : dateService.getCurrentDateTime() > end
        ? strategyStatuses[1]
        : strategyStatuses.slice(2)[Math.floor(Math.random() * (strategyStatuses.length - 2))];

    strategies.push({
      strategy_id: 1000 + i,
      strategy_name: `Strategy ${i}`,
      merchant_name: merch.merchant_name,
      strategy_description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras iaculis mi at
				turpis congue, eget rutrum odio malescuada. Curabitur eu mollis purus. Aliquam
				bibendum accumsan nisi vel mattis`,
      strategy_brands: ['Nike', 'Adidas'],
      strategy_categories: ['Shoes', 'Sneakers'],
      strategy_labels: ['sale', 'vendor_funded', 'product_launch', 'share_of_voice'],
      strategy_fee_type: feeTypes[Math.floor(Math.random() * feeTypes.length)],
      commission_rate:
        pricingModel !== 2 && pricingModel !== 4
          ? String(Math.floor(Math.random() * 100))
          : parseFloat(Math.random()).toFixed(2),
      publisher_total_earnings: (parseFloat(publisherEPC) * clicks).toFixed(2),
      publisher_epc: epc,
      clicks,
      strategy_datetime_start: dateService.toIso8601UtcDatetime(start),
      strategy_datetime_end: dateService.toIso8601UtcDatetime(end),
      visible_to: [Math.round(Math.random() * (1051 - 1049) + 1049)],
      merchant_in_network: [true, false][Math.round(Math.random())],
      merch_id: Math.floor(Math.random() * 10 + 1000),
      strategy_is_enabled: [true, false][Math.round(Math.random())],
      strategy_status: currentStrategyStatus,
    });
  }

  return {
    ...merch,
    merch_id: merchId,
    logo_url: logoUrl,
    marketplace_epc: marketplaceEPC,
    commission_rate: commissionRate,
    evergreen_rate: evergreenRate,
    pricing_model: pricingModel,
    publisher_epc: publisherEPC,
    clicks,
    publisher_total_earnings: publisherTotalEarnings,
    strategies,
    is_in_network: !!Math.floor(Math.random() * 2),
    is_new: !!Math.floor(Math.random() * 2),
  };
});

const mockResponses = {
  partners: mockResponse,
  strategies: mockResponse.reduce((acc, val) => acc.concat(val.strategies), []),
};

const presetDateRanges = dateService.getPresetDateRanges();
const dateRanges = ['sevenDay', 'thirtyDay', 'ninetyDay', 'thisMonth', 'lastMonth', 'halfYear'].map(
  range => {
    return {
      ...presetDateRanges[range],
      name: range,
      unit: range === 'halfYear' ? 'month' : 'day',
    };
  },
);

// SortBy Dropdown Options
const sortOptions = [
  { label: 'Strategy Rate', value: 'strategy_rate', direction: 'desc' },
  { label: 'Partner', value: 'merchant_name', direction: 'asc' },
  { label: 'Baseline Rate', value: 'commission_rate', direction: 'desc', dropdown: true },
  { label: 'Your Clicks', value: 'clicks', direction: 'desc' },
  { label: 'Your Earnings', value: 'publisher_total_earnings', direction: 'desc' },
  { label: 'Your EPC', value: 'publisher_epc', direction: 'desc' },
];

const detailsDropdown = [
  { label: 'Commission', value: 'strategy_rate' },
  { label: 'CPC', value: 'strategy_bid' },
  { label: 'Date Expected', value: 'strategy_datetime_start' },
  { label: 'Date Expires', value: 'strategy_datetime_end' },
];
// Sort By Dropdown options for specific headers
const headerSortOptions = [
  {
    label: 'Baseline Rate',
    value: 'commission_rate',
    direction: 'desc',
    dropdown: [
      { label: 'Commission', value: 'commission_rate' },
      { label: 'CPC', value: 'cpc_rate' },
    ],
  },
  {
    label: 'Strategies',
    value: 'strategy_rate',
    direction: 'desc',
    dropdown: [
      { label: 'Commission', value: 'strategy_rate' },
      { label: 'CPC', value: 'strategy_bid' },
      { label: 'Number of Strategies', value: 'strategies' },
    ],
  },
  {
    label: 'Details',
    value: 'strategy_rate',
    direction: 'desc',
    dropdown: detailsDropdown,
  },
  { label: 'Strategy', value: 'strategy_name', direction: 'asc' },
  { label: 'Type', value: 'strategy_fee_type', direction: 'asc' },
  { label: 'Partner', value: 'merchant_name', direction: 'asc' },
  { label: 'Your Clicks', value: 'clicks', direction: 'desc' },
  { label: 'Your Earnings', value: 'publisher_total_earnings', direction: 'desc' },
  { label: 'Your EPC', value: 'publisher_epc', direction: 'desc' },
];

// Payment Model Dropdown Options
const defaultPaymentModels = [
  {
    label: 'CPA+',
    value: 4,
    selected: true,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras iaculis mi at
			turpis congue, eget rutrum odio malescuada. Curabitur eu mollis purus. Aliquam
			bibendum accumsan nisi vel mattis`,
  },
  {
    label: 'CPC',
    value: 1,
    selected: true,
    description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras iaculis mi at
			turpis congue, eget rutrum odio malescuada. Curabitur eu mollis purus. Aliquam
			bibendum accumsan nisi vel mattis`,
  },
];

// Partners Dropdown Options
const retailerOptions = [
  { label: 'All Partners', value: 'active', adminViewLabel: '' },
  { label: 'New Partners', value: 'new,active' },
];

// Campaign Label Dropdown Options
const campaignLabelOptions = [
  { label: 'Product Launch', value: '1', selected: true },
  { label: 'Sale', value: '2', selected: true },
  { label: 'Vendor Funded', value: '3', selected: true },
  { label: 'Share of Voice', value: '4', selected: true },
  { label: 'Preferred Publisher', value: '5', selected: true },
  { label: 'Growth Incentive', value: '6', selected: true },
];

const feeTypeOptions = [
  { label: 'Marketplace (Standard)', value: 'marketplace', selected: true },
  { label: 'Direct Deal', value: 'direct_deal', selected: true },
];

// Table Column Headers
const overviewTableHeaders = {
  partners: [
    ['Partner', '', 'Baseline Rate', 'Strategies'],
    ['Your Earnings', 'Your Clicks', 'Your EPC'],
  ],
  strategies: [
    ['Partner'],
    ['Strategy'],
    ['Type'],
    ['Details'],
    ['Your Earnings', 'Your Clicks', 'Your EPC'],
  ],
  'upcoming strategies': [
    ['Partner'],
    ['Strategy'],
    ['Type'],
    ['Details'],
    ['Your Earnings', 'Your Clicks', 'Your EPC'],
  ],
};

// Table Tabs
const tableTabs = [
  { label: 'All Partners', value: 'partners' },
  { label: 'All Strategies', value: 'strategies' },
  { label: 'Coming Soon', value: 'upcoming strategies' },
];

const RetailerOverview = () => {
  const [didMount, setDidMount] = useState(false);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(tableTabs[0]);

  const [columnHeaders, setColumnHeaders] = useState(overviewTableHeaders);

  const [partners, setPartners] = useState([]);
  const [strategies, setStrategies] = useState([]);
  const [mockData, setMockData] = useState(false);

  // TODO: Remove feature toggle when we're ready to show inactive merchants to pubs
  const [retailerFilterBy, setRetailerFilterBy] = useState(
    session.isAdminView ? ratesService.retailerOptions[0] : retailerOptions[0],
  );
  const [strategyFilterBy, setStrategyFilterBy] = useState(ratesService.strategyOptions[1]);
  const [dateRange, setDateRange] = useState(dateService.getPresetDateRanges().thirtyDay);
  const [retailerSortBy, setRetailerSortBy] = useState(sortOptions[3]);
  const [strategySortBy, setStrategySortBy] = useState(sortOptions[0]);
  const [headerSort, setHeaderSort] = useState(null);
  const [paymentModels, setPaymentModels] = useState(defaultPaymentModels);
  const [campaignLabels, setCampaignLabel] = useState(campaignLabelOptions);
  const [feeTypes, setFeeType] = useState(feeTypeOptions);
  const [searchQuery, setSearchQuery] = useState('');
  const [params, setParams] = useState({});
  const [searchTerm, setSearchTerm] = useState('');

  const comingSoonStrats =
    strategies && strategies.filter(strat => strat.strategy_status === 'upcoming');
  const partnerOnlySortParams = ['evergreen_rate'];
  const strategyOnlySortParams = []; // Keeping in case we decide to add here
  const tabDataMap = {
    'upcoming strategies': comingSoonStrats,
    strategies,
    partners,
  };
  const currentSort = activeTab.value === 'partners' ? retailerSortBy : strategySortBy;
  const currentSetSort = activeTab.value === 'partners' ? setRetailerSortBy : setStrategySortBy;
  const [currentHeader, setCurrentHeader] = useState(currentSort.label);
  const participatingTxt =
    activeTab.value === 'strategies' && !loading
      ? ratesService.getParticipatingDisplayTxt(tabDataMap.strategies, true)
      : null;

  useEffect(() => {
    setDidMount(true);
  }, []);

  useEffect(() => {
    setParams(prevState => {
      const pricingModels = paymentModels.reduce(
        (acc, model) => (model.selected ? [...acc, model.value] : acc),
        [],
      );

      return {
        ...prevState,
        date_from: dateService.formatDate(dateRange.startDate),
        date_to: dateService.formatDate(dateRange.endDate),
        pricing_models: pricingModels.join(','),
        filter_by: retailerFilterBy.value,
        strategy_status: strategyFilterBy.value !== 'all' ? strategyFilterBy.value : null,
        campaign_label: ratesService.getSelectedCampaignLabels(campaignLabels),
        fee_types: ratesService.getSelectedFeeType(feeTypes),
        page: 1,
        per_page: 500,
      };
    });
  }, [
    dateRange,
    retailerSortBy,
    strategySortBy,
    paymentModels,
    retailerFilterBy,
    strategyFilterBy,
    campaignLabels,
    feeTypes,
  ]);

  useEffect(() => {
    if (didMount) {
      setLoading(true);
      getTableData();
    }
  }, [params, mockData]);

  useEffect(() => {
    if (didMount) {
      if (searchQuery) {
        const searchParams = getSearchParams();
        setParams(prevState => {
          return {
            ...prevState,
            ...searchParams,
          };
        });
      } else {
        clearSearchParams();
      }
    }
  }, [searchQuery, feeTypes]);

  useEffect(() => {
    if (searchQuery) {
      clearSearchParams();
      setSearchTerm('');
    }
    if (['strategies', 'upcoming strategies'].includes(activeTab.value)) {
      currentSetSort(headerSortOptions[2]);
      setHeaderSort(headerSortOptions[2].dropdown[0]);
      setCurrentHeader(headerSortOptions[2].label);

      if (activeTab.value === 'upcoming strategies') {
        // Do not show "Date Expired" on Coming Soon tab
        headerSortOptions[2].dropdown = detailsDropdown.slice(0, -1);
      } else {
        headerSortOptions[2].dropdown = detailsDropdown;
      }
    }

    if (didMount) {
      resetParams();
      analyticService.trackEvent('NRP Retailer Overview', 'Click', `${activeTab.value} tab`);
    }
  }, [activeTab]);

  function resetParams() {
    setCampaignLabel(campaignLabelOptions);
    setFeeType(feeTypeOptions);
    setSearchQuery('');
    setRetailerFilterBy(session.isAdminView ? ratesService.retailerOptions[0] : retailerOptions[0]);
    setStrategyFilterBy(ratesService.strategyOptions[1]);
    setPaymentModels(defaultPaymentModels);
    setDateRange(dateService.getPresetDateRanges().thirtyDay);
  }

  function getVisiblePartners(partners) {
    return session.isAdminView
      ? partners.data.data[0].stats
      : partners.data.data[0].stats.filter(partner => partner.is_in_network);
  }

  function getTableData() {
    if (mockData) {
      const { partners, strategies } = mockResponses;
      setPartners(partners.filter(partner => partner.is_in_network));
      setStrategies(strategies);
      setLoading(false);
    } else if (params.search_type) {
      const parameters = getParameters(activeTab.value);
      ratesService.getDataFromActiveTab(activeTab.value, parameters).then(resp => {
        if (['strategies', 'upcoming strategies'].includes(activeTab.value)) {
          const strategyStats = resp.data.data[0].stats;
          setStrategies(strategyStats);
        } else {
          setPartners(getVisiblePartners(resp));
        }
        setLoading(false);
      });
    } else {
      const ratesParams = getParameters('partners');
      const strategiesParams = getParameters('strategies');
      Promise.all([
        ratesService.getRates(ratesParams),
        ratesService.getStrategies(strategiesParams),
      ]).then(([partners, strategies]) => {
        setPartners(getVisiblePartners(partners));
        const strategyStats = strategies.data.data[0].stats;
        setStrategies(strategyStats);
        setLoading(false);
      });
    }
  }

  function getSearchParams() {
    const paramMap = {
      partners: 'merchant_name',
      strategies: 'strategy_name',
      'upcoming strategies': 'strategy_name',
    };
    return {
      search_type: paramMap[activeTab.value],
      search_query: searchQuery,
    };
  }

  function clearSearchParams() {
    const newParams = { ...params };
    if (newParams.hasOwnProperty('search_type') && newParams.hasOwnProperty('search_query')) {
      delete newParams.search_type;
      delete newParams.search_query;
      setParams(newParams);
    }
  }

  function getLeftDisplayTxt() {
    if (loading) return <h1>-</h1>;

    const data = tabDataMap[activeTab.value];
    const dataLen =
      activeTab.value === 'partners'
        ? ratesService.getVisibleDataCount(data, true)
        : ratesService.getVisibleDataCount(data, true, true);

    const filterByLabel =
      activeTab.value === 'partners' && session.isAdminView
        ? `${retailerFilterBy.adminViewLabel}`
        : '';

    const displayTxt = !dataLen
      ? `No ${filterByLabel}`
      : dataLen === 1
      ? `Displaying 1 ${filterByLabel}`
      : `Displaying ${dataLen} ${filterByLabel}`;

    const units =
      dataLen === 1
        ? activeTab.value.endsWith('strategies')
          ? `${activeTab.value.substring(0, activeTab.value.length - 3)}y`
          : activeTab.value.substring(0, activeTab.value.length - 1)
        : activeTab.value;

    const activeVerbiage =
      activeTab.value === 'strategies' && strategyFilterBy.value !== 'all'
        ? ` ${strategyFilterBy.value} `
        : ' ';
    return <h1>{`${displayTxt}${activeVerbiage}${units}`}</h1>;
  }

  function getParameters(tab) {
    const strategiesParams = {
      ...params,
      order_by: strategySortBy.value,
      direction: strategySortBy.direction,
    };

    const parameters = {
      strategies: strategiesParams,
      'upcoming strategies': strategiesParams,
      partners: {
        ...params,
        order_by: retailerSortBy.value,
        direction: retailerSortBy.direction,
      },
    };

    return parameters[tab];
  }

  const tabs = tableTabs.map((tab, idx) => {
    const strategyCount =
      tab.value === 'upcoming strategies' && comingSoonStrats
        ? ratesService.getVisibleDataCount(comingSoonStrats, true)
        : strategies && ratesService.getVisibleDataCount(strategies, true, true);
    const countLabel = ['upcoming strategies', 'strategies'].includes(tab.value) ? (
      <span className="count">{strategyCount}</span>
    ) : null;

    return ['partners', activeTab.value].includes(tab.value) || strategyCount ? (
      <span
        key={idx}
        className={`tab ${tab.value === activeTab.value ? 'active' : ''}`}
        onClick={() => setActiveTab(tab)}
      >
        <span>{tab.label}</span>
        {countLabel}
      </span>
    ) : null;
  });

  const overviewTable = !loading ? (
    <OverviewTable
      data={tabDataMap[activeTab.value]}
      columnHeaders={columnHeaders[activeTab.value]}
      tab={activeTab.value}
      sortOptions={ratesService.getTabSortOptions(
        headerSortOptions,
        activeTab,
        strategyOnlySortParams,
        partnerOnlySortParams,
      )}
      sortBy={currentSort}
      setSortBy={currentSetSort}
      headerSort={headerSort}
      setHeaderSort={setHeaderSort}
      currentHeader={currentHeader}
      setCurrentHeader={setCurrentHeader}
      overview={true}
    />
  ) : null;

  const paymentModelsDropdown =
    activeTab.value === 'partners' ? (
      <PaymentModelsDropdown paymentModels={paymentModels} setPaymentModels={setPaymentModels} />
    ) : null;

  const partnersDropdown =
    activeTab.value === 'partners' ? (
      session.isAdminView ? (
        <RetailersDropdown
          retailerOptions={ratesService.retailerOptions}
          filterBy={retailerFilterBy}
          setFilterBy={setRetailerFilterBy}
          type="new-partner-admin"
        />
      ) : (
        <RetailersDropdown
          retailerOptions={retailerOptions}
          filterBy={retailerFilterBy}
          setFilterBy={setRetailerFilterBy}
          type="new-partner"
        />
      )
    ) : null;

  const strategiesDropdown =
    activeTab.value === 'strategies' ? (
      <StrategiesDropdown
        strategyOptions={ratesService.strategyOptions}
        filterBy={strategyFilterBy}
        setFilterBy={setStrategyFilterBy}
      />
    ) : null;

  const mocksButton = session.isAdminView ? (
    <button onClick={() => setMockData(!mockData)}>Mocks</button>
  ) : null;

  const strategyDropdowns = ['strategies', 'upcoming strategies'].includes(activeTab.value) ? (
    <>
      <div className="campaign-label-dropdown">
        <ConfirmDropdown
          items={campaignLabels}
          updateItems={setCampaignLabel}
          itemType="campaign-labels"
        />
      </div>
      <div className="fee-type-dropdown">
        <ConfirmDropdown items={feeTypes} updateItems={setFeeType} itemType="fee-types" />
      </div>
    </>
  ) : null;

  const datePicker =
    activeTab.value !== 'upcoming strategies' && params.date_to ? (
      <div className="date-picker">
        <DatePicker
          eventPrefix="NRP Retailer Overview Date Picker"
          dateRange={ratesService.getDateRange(params)}
          setDateRange={(startDate, endDate) => setDateRange({ startDate, endDate })}
          allowFutureDates={true}
        />
      </div>
    ) : null;

  return (
    <div className="retailer-overview-container fs-unmask">
      <h1>Rates and Strategies</h1>

      <div className="tabs">
        {tabs}
        {datePicker}
      </div>

      <div className="search-bar">
        <SearchBar
          setSearchQuery={setSearchQuery}
          placeholder={`Search for a ${
            activeTab.value === 'partners' ? 'partner...' : 'strategy...'
          }`}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          loading={loading}
          loadingSpinner={true}
          xIcon={true}
        />
      </div>

      <div className="header">
        <div className="toggles">
          {getLeftDisplayTxt()}
          <h1>{participatingTxt}</h1>
          {mocksButton}
        </div>

        <div className="filters admin">
          <div className="row">
            {strategiesDropdown}
            {partnersDropdown}
            {paymentModelsDropdown}
            {strategyDropdowns}
          </div>
        </div>
      </div>

      {overviewTable}
    </div>
  );
};

export default RetailerOverview;
